import { useContext, useEffect, useState } from 'react'
import apiV2 from '../../services/apiV2';
import { toast } from 'react-toastify';

export default function PricingCards({ plans = [], paymentConfirmed, setPaymentConfirmed }) {
  const [selected, setSelected] = useState(null);
  const [number, setNumber] = useState("");
  const [isValid, setIsValid] = useState(false)
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    if (!paymentConfirmed) return;

    setPayment(null);
    setSelected(null);
    setNumber("")
    setIsValid(false)
    const timer = setTimeout(() => {
      setPaymentConfirmed(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [paymentConfirmed, setPaymentConfirmed]);




  async function handlePixCreate(planId) {
    const payload = {
      planoId: planId,
      Number: number,
    };

    try {
      const { data } = await apiV2.post("/buyToken", payload);

      setPayment(data);

      toast.success("PIX gerado com sucesso!");
    } catch (err) {
      console.log(err);

      toast.error(
        err?.response?.data?.error || "Erro ao gerar o PIX"
      );
    }
  }

  useEffect(() => {
    setIsValid(
      selected !== "" &&
      number.replace(/\D/g, "").length >= 11
    );
  }, [number, selected]);


  return (
    <div className="space-y-6">
      {!payment && (<>
        <div className="grid grid-cols-3 gap-3">
          {plans.map((plan) => {
            const isSelected = selected === plan.id;

            return (
              <div
                key={plan.id}
                onClick={() => setSelected(plan.id)}
                className={`relative rounded-xl p-5 cursor-pointer transition-all duration-200 ${isSelected
                  ? "border-2 border-violet-500 bg-violet-500/10"
                  : "border border-white/10 bg-white/[0.03] hover:border-violet-500/40"
                  }`}
              >
                {/* Indicador */}
                <div
                  className={`absolute top-4 right-4 w-5 h-5 rounded-full border-2 flex items-center justify-center ${isSelected
                    ? "border-violet-500 bg-violet-500"
                    : "border-white/20"
                    }`}
                >
                  {isSelected && (
                    <svg width="9" height="9" viewBox="0 0 8 8" fill="none">
                      <path
                        d="M1.5 4L3.5 6L6.5 2"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>

                {/* Badge de desconto */}
                {plan.discountPercent > 0 && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="px-3 py-1 rounded-full bg-emerald-500 text-white text-xs font-semibold">
                      {plan.discountPercent}% OFF
                    </span>
                  </div>
                )}

                <div className="space-y-1">
                  <h3 className="text-white text-lg font-semibold">
                    {plan.name}
                  </h3>

                  <div className="flex items-end gap-1">
                    <span className="text-3xl font-bold text-white">
                      {Number(plan.price).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </span>
                  </div>

                  <p className="text-violet-400 font-medium">
                    {plan.quantity.toLocaleString("pt-BR")} Tokens
                  </p>
                </div>

                <div className="mt-5 space-y-2 text-sm text-white/60">
                  <div className="flex items-center gap-2">
                    ✓ Tokens adicionados imediatamente
                  </div>

                  <div className="flex items-center gap-2">
                    ✓ Sem expiração imediata
                  </div>

                  {plan.discountPercent > 0 && (
                    <div className="flex items-center gap-2 text-emerald-400">
                      ✓ Economia de {plan.discountPercent}%
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div className="space-y-2">
          <label className="text-white/70 text-sm">
            Número de telefone
          </label>

          <input
            type="tel"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="(44) 99999-9999"
            className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-white placeholder:text-white/30 outline-none focus:border-violet-500 transition"
          />
        </div>

        <button
          disabled={!isValid}
          className={`w-full py-3 rounded-xl font-semibold transition ${isValid
            ? "bg-violet-600 hover:bg-violet-500 text-white"
            : "bg-white/10 text-white/40 cursor-not-allowed"
            }`}
          onClick={() => handlePixCreate(selected)}
        >
          {selected
            ? `Comprar ${plans.find((p) => p.id === selected)?.name}`
            : "Selecione um pacote"}
        </button>
      </>
      )}


      {paymentConfirmed ? (
        <div className="mt-6 rounded-xl border border-green-500/30 bg-green-500/10 p-6 text-center">
          <div className="text-5xl mb-3">✅</div>

          <h3 className="text-xl font-bold text-green-400">
            Pagamento confirmado!
          </h3>

          <p className="text-white/70 mt-2">
            Seus tokens foram creditados com sucesso.
          </p>
        </div>
      ) : payment && (
        <div className="mt-6 rounded-xl border border-white/10 bg-white/[0.03] p-5 space-y-4">

          <div className="text-center">
            <h3 className="text-white text-lg font-semibold">
              Pagamento PIX
            </h3>

            <p className="text-white/50 text-sm mt-1">
              Escaneie o QR Code ou copie o código abaixo.
            </p>
          </div>

          <div className="flex justify-center">
            <img
              src={payment.pix.qrCodeUrl}
              alt="QR Code PIX"
              className="w-56 h-56 rounded-lg bg-white p-2"
            />
          </div>

          <div className="rounded-lg bg-black/20 p-3">
            <p className="text-white/40 text-xs mb-1">
              Valor
            </p>

            <p className="text-white text-2xl font-bold">
              {Number(payment.value).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </p>
          </div>

          <div>
            <p className="text-white/40 text-xs mb-2">
              PIX Copia e Cola
            </p>

            <textarea
              readOnly
              value={payment.pix.copyPaste}
              rows={4}
              className="w-full rounded-lg bg-black/20 border border-white/10 text-white p-3 text-xs resize-none"
            />
          </div>

          <button
            onClick={() => {
              navigator.clipboard.writeText(payment.pix.copyPaste);
              toast.success("Código PIX copiado!");
            }}
            className="w-full py-3 rounded-xl bg-violet-600 hover:bg-violet-500 text-white font-semibold"
          >
            Copiar código PIX
          </button>
        </div>
      )}
    </div>



  );
}